import { t } from '@lingui/macro';
import type { ApiClient } from '@prismo-io/schemas';
import { z } from 'zod';

const ParamsSchema = z.object({
  id: z.string().uuid(),
});

export type ParamsSchemaT = z.infer<typeof ParamsSchema>;

const ResultSchema = z.boolean();

export type ResultSchemaT = z.infer<typeof ResultSchema>;

export const deleteExperience = async (
  client: ApiClient,
  experienceId: string
): Promise<ResultSchemaT> => {
  const {
    data: { session },
  } = await client.auth.getSession();

  if (!session) {
    throw new Error(t`Vous devez être connecté.`);
  }

  const userId = session.user.id;

  const validExperience = ParamsSchema.parse({ id: experienceId });

  try {
    await client
      .from('quark_experiences')
      .delete()
      .eq('id', validExperience.id)
      .eq('user_id', userId)
      .throwOnError();
  } catch (error) {
    throw error;
  }

  await client
    .from('quark_experiences_industries')
    .delete()
    .eq('experience_id', validExperience.id)
    .throwOnError();

  return ResultSchema.parse(true);
};
